<template>
  <div align="center">
    <v-container xs12 fluid class="pt-0">
      <v-card class="pa-2 mb-3 card-r pb-2 shadow-1">
        <v-toolbar class="primary card-r pl-3 text-white">
          <div class="text-xs-left f-20">Overview</div>
        </v-toolbar>
        <v-container fluid grid-list-md class="pa-0 pt-2">
          <v-layout row wrap>
            <v-flex d-flex lg4 sm6 xs12>
              <v-card class="card-r boxShadow b-border text-primary pa-3" flat xs12 sm6>
                <br>
                <v-icon class="text-primary f-40">fas fa-users</v-icon>
                <p
                  class="mt-0 mb-0 text-xs-center font-weight-medium subheading font-weight-light"
                >CUSTOMERS</p>
                <span
                  class="display-0.75 text-xs-center headline font-weight-bold"
                >{{clubs.total_clubs}}</span>
              </v-card>
            </v-flex>

            <v-flex d-flex lg4 sm6 xs12>
              <v-card class="card-r boxShadow text-red pa-3 r-border" flat xs12>
                <!--<v-card class="card-r no-shadow red accent-4 white&#45;&#45;text pa-3 " flat xs12>-->
                <br>
                <!--<v-icon class="white&#45;&#45;text">fas fa-bars</v-icon>-->
                <v-icon class="text-red f-40">fas fa-bars</v-icon>
                <p class="mt-0 mb-0 text-xs-center font-weight-medium">SUBSCRIPTIONS</p>
                <span
                  class="display-0.75 text-xs-center headline font-weight-bold"
                >{{clubs.active_clubs}}</span>
              </v-card>
            </v-flex>

            <v-flex d-flex lg4 sm6 xs12>
              <v-card class="card-r boxShadow g-border text-green pa-3" flat xs12>
                <!--<v-card class="card-r no-shadow green accent-4 white&#45;&#45;text pa-3 " flat  xs12>-->
                <br>
                <!--<v-icon class="white&#45;&#45;text">fas fa-money-check</v-icon>-->
                <v-icon class="text-green f-40">fas fa-money-check-alt</v-icon>
                <p class="mt-0 mb-0 text-xs-center font-weight-medium">EARNINGS</p>
                <span
                  class="display-0.75 text-xs-center headline font-weight-bold"
                >kr {{earningData.total_balance}}</span>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <v-card class="pa-2 card-r mb-3 shadow-1">
      <v-toolbar class="primary card-r pl-3 text-white">
          <div class="text-xs-left f-20">Withdraw Requests</div>
        </v-toolbar>
        <div class="Withdraw">
          <div class="table2 pa-1 pt-2">
            <withdraw-requests-table
              class="pt-0 mt-0"
              v-if="loading===false"
              :headers="headers"
              :items="withdrawData"
              :pagination="pagination"
              align="center"
            ></withdraw-requests-table>
          </div>
          <!-- <notifications group="error" position="bottom center"/> -->
          <!-- <notifications group="Success" position="bottom center"/> -->
        </div>
      </v-card>
    </v-container>
    <!-- <notifications group="error" position="bottom center" />
    <notifications group="Success" position="bottom center" />-->
  </div>
</template>

<script>
/* eslint-disable */

import WithdrawRequestsTable from "@/components/WithdrawRequestsTable.vue";
import SearchPanel from "@/components/SearchPanel.vue";
//import Bar from "@components/chart/Barchart.vue";
import D3BarChart from "vue-d3-barchart";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Home",
  data: () => ({
    selected: [],
    /* ...mapState([
			"withdrawData"
        ]),*/
    headers: [
      {
        text: "Date",
        value: "date"
      },
      {
        text: "School Name",
        value: "club_name"
      },
      {
        text: "Email",
        value: "admin_email"
      },
      {
        text: "Withdraw Amount",
        value: "request_amount"
      },
      {
        text: "Status",
        value: "status"
      }
    ]
  }),

  methods: {
    ...mapActions("clubs", ["loadClubs"])
  },

  created: function() {
    Store.dispatch("getAllWithdraw");
    // this.withdrawData = Store.state.withdrawData;

    this.loadClubs();
    //earning home
    Store.dispatch("getEarningsTotalAmount");
    // this.earningData = Store.state.earningData;
  },

  /*created: function () {
		Store.dispatch('getAllEarnings')
		this.earningData = Store.state.earningData;
	},*/
  computed: {
    ...mapState({
      earningData: "earningData",
      withdrawData: "withdrawData",
      pagination: "pagination",
      loading: "loading",
      mode: "mode"
    }),
    ...mapGetters("clubs", ["clubs"])
  },

  components: {
    WithdrawRequestsTable,
    SearchPanel,
    D3BarChart
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/pages/Home.vue